import React from 'react'
import { Frequency } from '@/enums/Frequency'
import DailyDatePicker from '@/components/Editors/DailyDatePicker'
import WeeklyDatePicker from '@/components/Editors/WeeklyDatePicker'
import BiweeklyDatePicker from '@/components/Editors/BiweeklyDatePicker'
import MonthlyDatePicker from '@/components/Editors/MonthlyDatePicker'
import QuarterlyDatePicker from '@/components/Editors/QuarterlyDatePicker'
import YearlyDatePicker from '@/components/Editors/YearlyDatePicker'

class DateSelector extends React.Component {
  render () {
    switch (this.props.frequency) {
      case Frequency.DAILY: return <DailyDatePicker {...this.props} />
      case Frequency.WEEKLY: return <WeeklyDatePicker {...this.props} />
      case Frequency.BIWEEKLY: return <BiweeklyDatePicker {...this.props} />
      case Frequency.MONTHLY: return <MonthlyDatePicker {...this.props} />
      case Frequency.QUARTERLY: return <QuarterlyDatePicker {...this.props} />
      case Frequency.YEARLY: return <YearlyDatePicker {...this.props} />
      default: return <div>UNKNOWN FREQUENCY... [{this.props.frequency}]</div>
    }
  }
}

export default DateSelector



// WEBPACK FOOTER //
// ./src/components/Editors/DateSelector.js